import { ESite_UserSync } from '~/src/dash/api/console-api';

export interface IUserSync {
  key: ESite_UserSync;
  text: string;
}

export const userSyncModels: IUserSync[] = [
  { key: ESite_UserSync.Site_User_Sync_UNKNOWN, text: 'None' },
  // the lines below are sorted alphabetically
  { key: ESite_UserSync.Site_User_Sync_APPNEXUS, text: 'AppNexus' },
  { key: ESite_UserSync.Site_User_Sync_BEACHFRONT, text: 'BeachFront' },
  { key: ESite_UserSync.Site_User_Sync_CADENT, text: 'Cadent, Aperture MX' },
  { key: ESite_UserSync.Site_User_Sync_FREEWHEEL, text: 'Freewheel' },
  { key: ESite_UserSync.Site_User_Sync_INDEX, text: 'Index' },
  { key: ESite_UserSync.Site_User_Sync_PUBMATIC, text: 'Pubmatic' },
  { key: ESite_UserSync.Site_User_Sync_RICHAUDIENCE, text: 'Rich Audience' },
  { key: ESite_UserSync.Site_User_Sync_RUBICON, text: 'Rubicon' },
  { key: ESite_UserSync.Site_User_Sync_SMARTADSERVER, text: 'Smart Ad Server' },
  { key: ESite_UserSync.Site_User_Sync_TEADS, text: 'Teads' },
  { key: ESite_UserSync.Site_User_Sync_THETRADEDESK, text: 'The Trade Desk' },
  { key: ESite_UserSync.Site_User_Sync_TRIPLELIFT, text: 'TripleLift' },
  { key: ESite_UserSync.Site_User_Sync_UNRULY, text: 'Nexxen CTRL' },
  { key: ESite_UserSync.Site_User_Sync_VERIZON, text: 'Verizon' },
];
